import { createContext } from "react";
import { useState } from "react";

const AppDataContext = createContext();

const AppDataProvider = ({ children }) => {
  const [isNotification, setIsNotification] = useState(false);
  const [notificationText, setNotificationText] = useState("");
  const [formStarted, setFormStarted] = useState(false);

  // Toggle notification with provided text for 2 seconds
  const handleNotification = (notificationText) => {
    setNotificationText(notificationText);
    setIsNotification(true);
    const timeout = setTimeout(() => {
      setNotificationText("");
      setIsNotification(false);

      return () => clearTimeout(timeout);
    }, 2000);
  };

  return (
    <AppDataContext.Provider
      value={{
        isNotification,
        handleNotification,
        notificationText,
        formStarted,
        setFormStarted,
      }}
    >
      {children}
    </AppDataContext.Provider>
  );
};

export { AppDataProvider, AppDataContext };
